"use client"

import { useEffect, useRef } from "react"

type CountUpProps = {
  to: number
  dur?: number
  fmt?: (n: number) => string
}

const defaultFmt = (n: number) => Math.round(n).toLocaleString("en-US")

export function CountUp({ to, dur = 1600, fmt }: CountUpProps) {
  const spanRef = useRef<HTMLSpanElement>(null)
  const stateRef = useRef({ from: 0, to: 0, start: 0, current: 0, dur })
  const fmtRef = useRef(fmt ?? defaultFmt)
  fmtRef.current = fmt ?? defaultFmt

  useEffect(() => {
    const s = stateRef.current
    s.from = s.current
    s.to = to
    s.start = performance.now()
    s.dur = dur
    const tick = () => {
      const t = Math.min(1, (performance.now() - s.start) / s.dur)
      const eased = 1 - (1 - t) ** 3
      s.current = s.from + (s.to - s.from) * eased
      if (spanRef.current) spanRef.current.textContent = fmtRef.current(s.current)
      if (t >= 1) clearInterval(id)
    }
    const id = setInterval(tick, 16)
    tick()
    return () => clearInterval(id)
  }, [to, dur])

  return <span ref={spanRef}>{fmtRef.current(stateRef.current.current)}</span>
}
